module.exports = __webpack_public_path__ + "img/wiperx_03.742d5702.jpg";